import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const VideoContainer = styled.figure`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  margin-top: calc(var(--fr) * 2);
  margin-bottom: calc(var(--fr) * 2.5);

  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const ArticleVideo = ({ videoId, showControls, autoPlay, name }) => {
  const controls = showControls ? '1' : '0';
  const autoplay = autoPlay ? '1' : '0';
  const options = `controls=${controls}&autoplay=${autoplay}`;
  const src = `https://www.youtube.com/embed/${videoId}?${options}`;
  return (
    <VideoContainer>
      <iframe
        src={src}
        className="video"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
        title={name}
      />
    </VideoContainer>
  );
};

ArticleVideo.propTypes = {
  videoId: PropTypes.string,
  showControls: PropTypes.bool,
  autoPlay: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

export default ArticleVideo;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/article/ArticleVideo.js